import Support from '../../../profile/support';

const ShopSupport = () => {
  return (
    <>
      <Support />
    </>
  );
};

export default ShopSupport;
